const agentRoles = Object.freeze({
  operator: { value: "operator", displayValue: "Operator" },
  manager: { value: "manager", displayValue: "Manager" },
  admin: { value: "admin", displayValue: "Admin" },
});

const agentDocType = Object.freeze({
  agent: "agent",
  invite: "invite",
});

const isAgentInvite = (agent) => {
  return agent && agent.docType === agentDocType.invite;
};

const getAgentRoleDisplayValue = (agentRole) => {
  return agentRole === agentRoles.operator.value
    ? agentRoles.operator.displayValue
    : agentRole === agentRoles.manager.value
    ? agentRoles.manager.displayValue
    : agentRole === agentRoles.admin.value
    ? agentRoles.admin.displayValue
    : null;
};

const getAllAgentRoles = () => {
  return [agentRoles.operator, agentRoles.manager, agentRoles.admin];
};

const auditOperationTypeMap = Object.freeze({
  agent: "Agent",
  user: "User",
  invite: "Invite",
});

const getAuditOperationTypeDisplayValue = (auditOperationType) => {
  return auditOperationType in auditOperationTypeMap
    ? auditOperationTypeMap[auditOperationType]
    : auditOperationType;
};

const auditOperations = Object.freeze([
  { value: "inviteAgent", displayName: "Invite Agent" },
  { value: "acceptInvite", displayName: "Accept Agent Invite" },
  { value: "revokeInvitation", displayName: "Revoke Agent Invite" },
  { value: "assignAgentRole", displayName: "Assign Agent Role" },
  { value: "activateAgent", displayName: "Activate Agent" },
  { value: "deactivateAgent", displayName: "Deactivate Agent" },
  { value: "deleteAgent", displayName: "Delete Agent" },
  { value: "deleteMfaEnrollment", displayName: "Delete User MFA Enrollment" },
  { value: "deleteAllMfaEnrollments",displayName: "Delete All MFA Enrollments"},
  { value: "regenerateMfaCode", displayName: "Regenerate User MFA Code" },
  { value: "blockUser", displayName: "Block User" },
  { value: "unblockUser", displayName: "Unblock User" },
  { value: "deleteUser", displayName: "Delete User" },
  { value: "bypassEmailVerification", displayName: "Bypass Email Verification"  },
  { value: "bypassMfa", displayName: "Bypass Mfa"  },
  { value: "requestPasswordResetTicket",  displayName: "Password Reset" },
  { value: "deleteDeviceCredential",  displayName: "Delete User Device Credential"  },
  { value: "sendCloudIdVerificationEmail",  displayName: "Send Verification Email"  },
  { value: "validateVerificationEmail", displayName: "Validate Verification Email"  },
  { value: "startChangeEmail",  displayName: "Email Change Requested" },
  { value: "completeChangeEmail", displayName: "Email Change Completed" },
]);

const getAuditOperationDisplayValue = (auditOperation) => {
  const idx = auditOperations.findIndex((entry) => {
    return entry.value === auditOperation;
  });
  return idx >= 0 ? auditOperations[idx].displayName : auditOperation;
};

const agentFieldNames = Object.freeze({
  email: "email",
  role: "role",
  status: "status",
  docType: "docType",
});

const userFieldNames = Object.freeze({
  name: "name",
  email: "email",
  auth0Id: "auth0Id",
});

const auditLogEntryFieldNames = Object.freeze({
  agentId: "agentId",
  agentEmail: "agentEmail",
  subjectId: "subjectId",
  subjectEmail: "subjectEmail",
  operation: "operation",
});

const psuedoAgentStatusInvitePending = Object.freeze({
  value: "invitePending",
  displayValue: "Invite Pending",
});

const agentStatuses = Object.freeze({
  active: { value: "active", displayValue: "Active" },
  deactivated: { value: "deactivated", displayValue: "Deactivated" },
});

const supportedLanguages = Object.freeze([
  { value: "de-DE", displayValue: "German" },
  { value: "en-GB", displayValue: "English (British)" },
  { value: "en-US", displayValue: "English (US)" },
  { value: "es-ES", displayValue: "Spanish" },
  { value: "fr-CA", displayValue: "French (Canadian)" },
  { value: "fr-FR", displayValue: "French" },
  { value: "nl-NL", displayValue: "Dutch" },
  { value: "pl-PL", displayValue: "Polish" },
  { value: "pt-PT", displayValue: "Portuguese" },
]);

const agentEmailMaxLength = 254;

export {
  agentRoles,
  getAllAgentRoles,
  getAgentRoleDisplayValue,
  psuedoAgentStatusInvitePending,
  agentStatuses,
  getAuditOperationDisplayValue,
  auditOperations,
  getAuditOperationTypeDisplayValue,
  isAgentInvite,
  auditLogEntryFieldNames,
  userFieldNames,
  agentFieldNames,
  agentDocType,
  supportedLanguages,
  agentEmailMaxLength,
};
